// Contrato comum dos formulários de criação do "+ Novo jogo" (geradores e
// quiz). Não anunciam o sucesso: quem anuncia é o assistente (notificação única). O título
// é do passo 3 do "+ Novo jogo", não do formulário: `resolveTitle` valida esse campo e devolve o texto (ou `null` se faltar).

export interface GeneratorProps {
  resolveTitle: () => Promise<string | null>;
  /** Id do registro criado (passatempo para a cruzada, jogo para os demais). */
  onCreated: (id: number) => void;
}

/** A mensagem do servidor (`response.data.msg`), ou o texto da tela. */
export function apiErrorMessage(e: unknown, fallback: string): string {
  const msg = (e as { response?: { data?: { msg?: unknown } } } | null)?.response?.data?.msg;
  return typeof msg === 'string' && msg ? msg : fallback;
}

export const fieldLabel: React.CSSProperties = {
  display: 'block',
  margin: '10px 0 4px',
  fontWeight: 600,
};
